import Vue from 'vue'
import PrintComponent from '@/modules/printModule/PrintComponent.vue'
Vue.component('PrintComponent', PrintComponent)
